import styled from "styled-components";

export const ComboBoxStyle = styled.div`
    display: flex;
    -webkit-box-align: center;
    align-items: center;
  
    select{
    border-radius: 7px;
    padding: 0px 15px;
    font-size: 15px;
    -webkit-box-pack: center;
    justify-content: center;
    cursor: pointer;
    min-width: 165px;
    height: 35px;
    background: rgb(0, 0, 0);
    color: #fff;
    font-family: "Lato Bold";
    
 
    }
`
